import createModel from './lib/create_model';

export default createModel({
  modelName: 'HelpAppContext',

  properties: {
    events: [],
    username: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/help_app_context.js